<template>
  <div class="crushing">
    <div class="rd-header rd-header--crushing">
      <h1 class="rd-h1">Krossning</h1>
    </div>
    <div v-if="record">
        <div class="container infobox">
          <div v-for="item in info" :key="item.label">
            <span class="infolabel">{{item.label}}:</span>{{item.value}}
          </div>
        </div>
        <div class="container">
          <h1 class="headers">Substanser</h1>
          <table>
            <tr class="table-row">
              <th>Namn</th><th>Id</th><th>Datum tillagd</th>
            </tr>
            <tr class="table-row" v-for="item in record.substances" :key="item.substanceId">
              <td>{{item.substanceName}}</td><td>{{item.substanceId}}</td><td>{{item.changeDate}}</td>
            </tr>
          </table>
        </div>

        <div class="container">
          <h1 class="headers">Läkemedel</h1>
          <table>
            <tr class="table-row">
              <th>Namn</th><th>Exempel</th><th>Npl-id</th><th>Form kod</th><th>Datum ändrad</th>
            </tr>
            <tr class="table-row" v-for="item in record.drugList" :key="item.nplId">
              <td>{{item.silDrugName}}</td><td>{{item.isExample ? 'Ja' : 'Nej'}}</td><td>{{item.nplId}}</td><td>{{item.silDrugFormCode}}</td><td>{{item.changeDate}}</td>
            </tr>
          </table>
        </div>

        <div class="container">
          <div v-for="rec in recommendations" :key="rec.recommendationTypeKey">
            <h1 class="headers">{{rec.recommendationTypeHeading}}</h1>
            <div v-html="rec.recordMarkupText" />
            <div v-if="rec.recordNotes.notes">
              <div class="reference-item" v-for="item in rec.recordNotes.notes" :key="item.noteId">
                {{item.noteId}} :  {{item.noteText}}
              </div>    
            </div>
          </div>
        </div>

        <div class="container">
          <h1 class="headers">Referenser</h1>
          <div class="reference-item" v-for="item in record.references" :key="item.referenceNumber">
            [{{item.referenceNumber}}] :  {{item.referenceText}}
          </div>
        </div>

    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from '@vue/composition-api'
import axios from 'axios'
import { sortBy } from 'lodash'

export default {
  name: 'CrushingViewSilFormat',
  props: ['id'],
  setup (props) {
    const record = ref({})

    onMounted(() => {
      getRecord()
    })
    const info = computed(() => {
      return record.value
      ? [
        {label: 'Rubrik', value: record.value.recordHeading},
        {label: 'Krossnings Id', value: record.value.recordKey},
        {label: 'Skapades', value: record.value.recordCreateDate},
        {label: 'Updaterades', value: record.value.recordChangeDate},
        {label: 'Läkemedelsform', value: record.value.silDrugFormTextSv},
        {label: 'Läkemedelsform kod', value: record.value.silDrugFormCode}
      ] : []
    })

    const recommendations = computed(() => {
      const sortorder = {'keyPeroral': 0, 'keyEnteral': 1, 'keyAlternative': 2, 'keyGeneral': 3}
      return sortBy(record.value.recommendations, (rec) => sortorder[rec.recommendationTypeKey])
    })

    function getRecord () {
      axios.get('crushingapi/getCrushingRecordForSilPreview', {params: { recordKey: props.id }})
        .then((result) => {
          if (result.data) {
            record.value = result.data
          }
        })
        .catch((error) => {
          console.log(error)
        })
    }
    return {
      info,
      record,
      recommendations
    }
  }
}
</script>
<style lang="scss" scoped>
.infobox {
    display: grid;
    gap: 1rem;
}
.container {
  padding: var(--container-block-padding) var(--container-inline-padding) 0 var(--container-inline-padding)
}
th:nth-child(n + 2) {
  padding-left: 1rem;
}
td:nth-child(n + 2) {
  padding-left: 1rem;
}
.infolabel {
  font-weight: 700;
  padding-right: 1rem;
}
.headers {
  font-size: 1.3rem;
}
.reference-item {
  padding-bottom: 6px;
  word-break: break-word;
}
</style>


